import {useCallback} from "react";

import {useGlobalEvent} from "~/contexts/event/GlobalEventBusContext";

import {useEditActions} from "./useEditActions";

export const useHotkeyManager = () => {
  const {handleCopy, handlePaste, handleDuplicate, handleDelete} =
    useEditActions();

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key.toLowerCase() === "c") {
        handleCopy();
      } else if (event.ctrlKey && event.key.toLowerCase() === "v") {
        handlePaste();
      } else if (event.ctrlKey && event.key.toLowerCase() === "d") {
        event.preventDefault();
        handleDuplicate();
      } else if (event.key === "Delete" || event.key === "Entf") {
        handleDelete();
      }
    },
    [handleCopy, handlePaste, handleDuplicate, handleDelete],
  );

  // Subscribe to global "keydown" events.
  useGlobalEvent("keydown", handleKeyDown);
};
